import React from "react";
import InfoPage from "../components/InfoPage";

function Privacy() {
  return (
    <InfoPage
      eyebrow="YOUR PRIVACY"
      title="Privacy Policy"
      subtitle="How information submitted through our website is handled."
      sections={[
        {
          title: "1. Information We Collect",
          content:
            "Placeholder: List the information you collect, such as names, contact details, and appointment preferences.",
        },
        {
          title: "2. How We Use Information",
          content:
            "Placeholder: Explain how information is used to respond to inquiries and manage appointment requests.",
        },
        {
          title: "3. Sharing and Service Providers",
          content:
            "Placeholder: Explain whether information is shared with booking, hosting, payment, or other service providers.",
        },
        {
          title: "4. Data Retention and Security",
          content:
            "Placeholder: Describe how long information is retained and the safeguards used to protect it.",
        },
        {
          title: "5. Your Choices and Rights",
          content:
            "Placeholder: Explain how visitors can request access, corrections, or deletion where applicable.",
        },
        {
          title: "6. Contact About Privacy",
          content:
            "Placeholder: Add the appropriate contact details for privacy questions and requests.",
        },
      ]}
    />
  );
}

export default Privacy;